// extracted by mini-css-extract-plugin
export default {"container":"notification_container__oklmX","newQuizzesContainer":"notification_newQuizzesContainer__FZFIG","textDraw":"notification_textDraw__sBPOZ"};